import { useEffect } from "react";
import { Reveal } from "../components/Reveal";
import Services from "../components/sections/Services";
import Impact from "../components/sections/Impact";
import Publications from "../components/sections/Publications";

export default function Practice() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" data-testid="practice-page">
      <div className="pt-32 pb-4">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-gold">The Practice</span>
            <h1 className="font-serif text-5xl md:text-7xl font-light mt-4 leading-none text-foreground">
              Consultations, impact <span className="text-gradient-gold italic">& research.</span>
            </h1>
            <p className="mt-6 text-muted-foreground md:text-lg font-light max-w-2xl">
              Everything you need to know about working with me — the sessions I offer, the impact of the work, and the research behind it.
            </p>
          </Reveal>
        </div>
      </div>

      <Services />
      <Impact />
      <Publications />
    </div>
  );
}
